import React from "react";
import { Modal } from "semantic-ui-react";
import { Button, Paragraph } from "hireart-components";

const GoogleCalendarSetupModal = ({ trigger }) => {
  const [open, setOpen] = React.useState(false);
  const [disabled, setDisabled] = React.useState(false);
  const [label, setLabel] = React.useState("Set up Google Calendar sync");

  const handleGoogleLogin = () => {
    setLabel("Please wait...");
    setDisabled(true);
    document.location.href = `/managers/calendar/redirect`;
  };

  return (
    <Modal
      onClose={() => setOpen(false)}
      onOpen={() => setOpen(true)}
      open={open}
      size="small"
      trigger={trigger}
    >
      <Modal.Header>
        Sync your calendar with Google <span className="new-label">NEW</span>
      </Modal.Header>
      <Modal.Content>
        <Paragraph
          size="small"
          text="If you connect your Google Calendar, your availability for HireArt interviews will update automatically.
          Interviews you schedule through HireArt will be added automatically to your Google Calendar."
        />
      </Modal.Content>
      <Modal.Actions>
        <Button
          label="Not now"
          size="md"
          outlined
          onClick={() => setOpen(false)}
        />
        <Button
          label={label}
          size="md"
          onClick={handleGoogleLogin}
          disabled={disabled}
        />
      </Modal.Actions>
    </Modal>
  );
};

export default GoogleCalendarSetupModal;
